var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid-container',{staticClass:"w-100",attrs:{"gap":"8px","cols":"auto","auto-rows":"max-content"}},[_c('custom-title',{attrs:{"type":"section","text":_vm.title}}),_vm._l((_vm.items),function(ref,i){
var title = ref.title;
var scheduled = ref.scheduled;
var to = ref.to;
return _c('communication-card',{key:i,staticClass:"white--text mb-1",attrs:{"title":title,"date":scheduled,"to":to,"max-width":"100%"}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }